const getList = () => {
  try {
    const { current, previous } = window.getBreadcrumbData();

    return [current, previous].find((page) => page?.page_type === "collection")
      .path;
  } catch (error) {
    // console.warn(error);
    return "";
  }
};

export default function formatDatalayerEcommerce({
  product,
  variant,
  key,
  customProperties,
}) {
  const list = getList();
  const variant_id = variant.id.replace("gid://shopify/ProductVariant/", "");
  const formatted = {
    currencyCode: product.helpers.currency,
    [key]: {
      actionField: {
        list,
      },
      products: [
        {
          id: variant.sku || variant_id,
          name: product.title,
          brand: product.vendor,
          category: product.productType,
          variant: variant.title,
          price: variant.price.amount,
          list,
          product_id: product.id.replace("gid://shopify/Product/", ""),
          variant_id,
          compare_at_price: variant.compareAtPrice?.amount || null,
          image: variant.image?.url,
          ...customProperties,
        },
      ],
    },
  };

  return formatted;
}
